import { useMemo } from "react";
import { Link } from "react-router-dom";

import studioImage01 from "../assets/studio-images/studio-image01.jpg";
import studioImage02 from "../assets/studio-images/studio-image02.jpg";
import studioImage03 from "../assets/studio-images/studio-image03.jpg";
import studioImage04 from "../assets/studio-images/studio-image04.jpg";
import studioImage05 from "../assets/studio-images/studio-image05.jpg";
import studioImage06 from "../assets/studio-images/studio-image06.jpg";
import studioImage07 from "../assets/studio-images/studio-image07.jpg";
import studioImage08 from "../assets/studio-images/studio-image08.jpg";
import studioImage09 from "../assets/studio-images/studio-image09.jpg";
import studioImage10 from "../assets/studio-images/studio-image10.jpg";
import studioImage11 from "../assets/studio-images/studio-image11.jpg"; 
import studioImage12 from "../assets/studio-images/studio-image12.jpg";
import studioImage13 from "../assets/studio-images/studio-image13.jpg";
import studioImage14 from "../assets/studio-images/studio-image14.jpg";
import studioImage15 from "../assets/studio-images/studio-image15.jpg";
import studioImage16 from "../assets/studio-images/studio-image16.jpg";
import studioImage17 from "../assets/studio-images/studio-image17.jpg";
import studioImage18 from "../assets/studio-images/studio-image18.jpg";
import studioImage19 from "../assets/studio-images/studio-image19.jpg";
import studioImage20 from "../assets/studio-images/studio-image20.jpg";
import studioImage21 from "../assets/studio-images/studio-image21.jpg";
import studioImage22 from "../assets/studio-images/studio-image22.jpg";
import studioImage23 from "../assets/studio-images/studio-image23.jpg";
import studioImage24 from "../assets/studio-images/studio-image24.jpg";
import studioImage25 from "../assets/studio-images/studio-image25.jpg";
import studioImage26 from "../assets/studio-images/studio-image26.jpg";
import studioImage27 from "../assets/studio-images/studio-image27.jpg";
import studioImage28 from "../assets/studio-images/studio-image28.jpg";
import studioImage29 from "../assets/studio-images/studio-image29.jpg";
import studioImage30 from "../assets/studio-images/studio-image30.jpg";
import studioImage31 from "../assets/studio-images/studio-image31.jpg";
import studioImage32 from "../assets/studio-images/studio-image32.jpg";
import studioImage33 from "../assets/studio-images/studio-image33.jpg";
import studioImage34 from "../assets/studio-images/studio-image34.jpg";
import studioImage35 from "../assets/studio-images/studio-image35.jpg";
import studioImage36 from "../assets/studio-images/studio-image36.jpg";
import studioImage37 from "../assets/studio-images/studio-image37.jpg";
import studioImage38 from "../assets/studio-images/studio-image38.jpg";
import studioImage39 from "../assets/studio-images/studio-image39.jpg";
import studioImage40 from "../assets/studio-images/studio-image40.jpg";
import studioImage41 from "../assets/studio-images/studio-image41.jpg";

const ALL_IMAGES = [
  studioImage01,
  studioImage02,
  studioImage03,
  studioImage04,
  studioImage05,
  studioImage06,
  studioImage07,
  studioImage08,
  studioImage09,
  studioImage10,
  studioImage11,
  studioImage12,
  studioImage13,
  studioImage14,
  studioImage15,
  studioImage16,
  studioImage17,
  studioImage18,
  studioImage19,
  studioImage20,
  studioImage21,
  studioImage22,
  studioImage23,
  studioImage24,
  studioImage25,
  studioImage26,
  studioImage27,
  studioImage28,
  studioImage29,
  studioImage30,
  studioImage31,
  studioImage32,
  studioImage33,
  studioImage34,
  studioImage35,
  studioImage36,
  studioImage37,
  studioImage38,
  studioImage39,
  studioImage40,
  studioImage41,
];

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export default function HomeGallerySection() {
  const images = useMemo(() => {
    return shuffleArray(ALL_IMAGES).slice(0, 6);
  }, []);

  return (
    <section className="border-t border-black/10 bg-[#fff7fb]">
      <div className="mx-auto max-w-7xl px-6 py-16 md:py-20">
        {/* Heading */}
        <div className="text-center">
          <p className="text-sm uppercase tracking-[0.3em] text-pink-500/80">
            Gallery
          </p>

          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-black md:text-4xl">
            A glimpse into our work
          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-black/65 md:text-base">
            Explore a curated collection of our photography, showcasing our
            style, creativity, and attention to detail.
          </p>
        </div>

        {/* Images */}
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {images.map((img, index) => (
            <div
              key={index}
              className="group overflow-hidden rounded-[1.75rem] border border-black/10 bg-white shadow-[0_20px_50px_rgba(0,0,0,0.08)]"
            >
              <div className="aspect-[9/16] w-full overflow-hidden">
                <img
                  src={img}
                  alt={`Gallery preview ${index + 1}`}
                  className="h-full w-full object-cover object-center transition duration-700 group-hover:scale-105"
                  loading={index < 3 ? "eager" : "lazy"}
                  decoding="async"
                />
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <Link
            to="/gallery"
            className="inline-flex rounded-full bg-pink-500 px-7 py-3 text-sm font-medium text-white transition hover:bg-pink-600"
          >
            View Full Gallery
          </Link>
        </div>
      </div>
    </section>
  );
}
